import React from "react";
import { Link } from "react-router-dom";
import Services from "./Services";


const Home = () => {
  return (
    <>
      <section className="hero-section" id="home">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Welcome to Lifetimeinfotech</h1>
            <p>
              We build innovative solutions for web, mobile, and enterprise
              platforms.
            </p>

            <div className="hero-buttons">
              <a href="/services" className="btn btn-primary">
                Our Services
              </a>
              <a href="/contact1" className="btn btn-secondary">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
{/* ABOUT US SECTION */}

<section className="about-section">

  <div className="about-container">

    <div className="about-image">
      <img src="/images/ab.jpg" alt="About us" />
    </div>

    <div className="about-content">
      <h2>About Us</h2>

      <p>
        Lifetimeinfotech is a leading software development company that
        specializes in building high-quality web applications, mobile apps,
        and enterprise solutions for businesses around the world.
      </p>

      <p>
        Our experienced team of developers, designers, and strategists work
        together to deliver innovative digital solutions that help companies
        grow faster and operate more efficiently.
      </p>

      <a href="/about" className="about-btn">Read More</a>
    </div>

  </div>

</section>

{/* WHY CHOOSE US */}

<section className="why-section">

  <div className="why-container">

    <div className="why-content">

      <h2>Why Choose Us</h2>

      <div className="why-item">
        <i className="bi bi-check-circle"></i>
        <p>Experienced team of developers and designers</p>
      </div>

      <div className="why-item">
        <i className="bi bi-check-circle"></i>
        <p>High quality scalable solutions</p>
      </div>

      <div className="why-item">
        <i className="bi bi-check-circle"></i>
        <p>On-time project delivery</p>
      </div>

      <div className="why-item">
        <i className="bi bi-check-circle"></i>
        <p>24/7 technical support</p>
      </div>

      <div className="why-item">
        <i className="bi bi-check-circle"></i>
        <p>Affordable pricing</p>
      </div>

    </div>

    <div className="why-image">
      <img src="/images/whychoose.jpg" alt="Why choose us"/>
    </div>

  </div>

</section>

     <section className="home-services">
  <div className="services-container">

    <p className="services-subtitle">OUR SERVICES</p>
    <h2 className="services-title">
      Custom IT Solutions for Your Business
    </h2>

   <div className="services-grid">

<Link to="/portfolio#mobile" className="service-card">
  <i className="bi bi-phone"></i>
  <h3>App Development</h3>
  <p>
    Build powerful mobile apps for iOS and Android platforms.
  </p>
</Link>

<Link to="/portfolio#web" className="service-card">
  <i className="bi bi-globe"></i>
  <h3>Web Development</h3>
  <p>
    Create stunning, responsive websites that drive engagement.
  </p>
</Link>

<Link to="/portfolio#uiux" className="service-card">
  <i className="bi bi-palette"></i>
  <h3>UI/UX Design</h3>
  <p>
    We create modern, user-friendly and responsive UI/UX designs
    that enhance user experience and improve engagement.
  </p>
</Link>

<Link to="/services#marketing" className="service-card">
  <i className="bi bi-megaphone"></i>
  <h3>Digital Marketing</h3>
  <p>
    Grow your business with data-driven digital marketing strategies.
  </p>
</Link>

</div>
  </div>
</section>

     <Services showHeader={false} />
<section className="detailed-services">

  <div className="detailed-container">

    <div className="detailed-card">

      <div className="service-icon">
        <i className="bi bi-lightbulb"></i>
      </div>

      <h3>Mobile App Development</h3>

      <p>
        Developing mobile apps over the years and collaborating on several
        different projects that fulfills your needs, we've gained profound
        expertise in this domain. We help you build mobile app development
        that brings in flawless customer retention and enterprise at a
        valuable amount.
      </p>

      <div className="tech-icons">
        <i className="bi bi-apple"></i>
        <i className="bi bi-android2"></i>
        <i className="bi bi-phone"></i>
      </div>

    </div>


    <div className="detailed-card">

      <div className="service-icon">
        <i className="bi bi-globe"></i>
      </div>

      <h3>Web Development</h3>

      <p>
        People nowadays are mobile first. So when you plan to create a
        website, we definitely build it mobile friendly with a robust
        backend along with fulfilling your web development requirements.
      </p>

      <div className="tech-icons">
        <i className="bi bi-filetype-html"></i>
        <i className="bi bi-filetype-css"></i>
        <i className="bi bi-filetype-js"></i>
        <i className="bi bi-bootstrap"></i>
      </div>

    </div>

    <div className="detailed-card">

  <div className="service-icon">
    <i className="bi bi-palette"></i>
  </div>

  <h3>UI/UX Design</h3>

  <p>
    We design intuitive and visually appealing user interfaces that
    enhance user experience and improve customer engagement across
    web and mobile platforms.
  </p>

  <div className="tech-icons">
    <i className="bi bi-bezier"></i>
    <i className="bi bi-vector-pen"></i>
    <i className="bi bi-grid-3x3"></i>
    <i className="bi bi-brush"></i>
  </div>

</div>

<div className="detailed-card">

  <div className="service-icon">
    <i className="bi bi-megaphone"></i>
  </div>

  <h3>Digital Marketing</h3>

  <p>
    We help businesses grow online through SEO, social media marketing,
    and targeted advertising campaigns that increase visibility,
    generate leads and boost conversions.
  </p>

  <div className="tech-icons">
    <i className="bi bi-search"></i>
    <i className="bi bi-graph-up"></i>
    <i className="bi bi-google"></i>
    <i className="bi bi-instagram"></i>
  </div>

</div>


    {/* <div className="detailed-card">

      <div className="service-icon">
        <i className="bi bi-controller"></i>
      </div>

      <h3>Game Development</h3>

      <p>
        The more entertaining we want the game to be, the more complex its
        coding can be. Our game developers are proficient enough to deliver
        you a game that gives users an amazing gaming experience.
      </p>

      <div className="tech-icons">
        <i className="bi bi-unity"></i>
        <i className="bi bi-cpu"></i>
      </div>

    </div> */}


    {/* <div className="detailed-card">

      <div className="service-icon">
        <i className="bi bi-palette"></i>
      </div>

      <h3>Product Design</h3>

      <p>
        We give a neat, decent and attractive look to your apps, websites
        and customized software. An attractive and soothing design
        provides a better user experience and enhances brand value.
      </p>

      <div className="tech-icons">
        <i className="bi bi-bezier"></i>
        <i className="bi bi-brush"></i>
      </div>

    </div> */}

  </div>

</section>
{/* Work Methodology Section */}

<section className="work-methodology">

  <div className="methodology-container">

    <h2 className="methodology-title">
      Work <span>Methodology</span>
    </h2>

    <div className="methodology-grid">

      <div className="method-card">
        <i className="bi bi-lightbulb"></i>
        <h3>Ideate</h3>
        <p>
          Every project starts with an ideation. And our job is to convert
          your ideas into reality to achieve your goal.
        </p>
      </div>

      <div className="method-card">
        <i className="bi bi-diagram-3"></i>
        <h3>Strategize</h3>
        <p>
          Once a 360 degree research is completed, we list down the
          strategies as pre-planning to build a robust development
          procedure.
        </p>
      </div>

      <div className="method-card">
        <i className="bi bi-tools"></i>
        <h3>Build</h3>
        <p>
          In this phase, our experts start building on your requirements
          and are committed to fulfill it to your expectations.
        </p>
      </div>

      <div className="method-card">
        <i className="bi bi-rocket"></i>
        <h3>Launch</h3>
        <p>
          With a green signal from our quality assurance experts, your
          product is ready to launch in the market delivering peak
          performance.
        </p>
      </div>

    </div>

  </div>

</section>
    </>
  );
};

export default Home;